import { atom } from 'recoil';
import { IIdiomaConfig } from '../../commons/types/crm';


export const configIdiomasAtom = atom<IIdiomaConfig[]>({
  key: 'configIdiomas', 
  default: [] as IIdiomaConfig[],
}); 
